import { ToolbarItemManifest } from "flow/entities/ToolbarItemManifest";

export default class ToolbarItemManifestEx extends ToolbarItemManifest {
    id: string;
    shouldBeVisible: (contextId: string) => boolean;
    viewModel?: KnockoutObservable<boolean>;
}
